import { mentorConstants } from "../../_constants";

const initialState = {};

// update mentor reducer
export const update_mentor_profile_reducer = (state = initialState, action) => {
  switch (action.type) {
    case mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        mentorData: action.payload,
      };
    case mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor profile
export const get_mentor_profile_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_PROFILE_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_PROFILE_DATA_ACTION_SUCCESS:
    case mentorConstants.UPDATE_MENTOR_PROFILE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        mentorProfileData: action.payload,
      };
    case mentorConstants.GET_MENTOR_PROFILE_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_mentor_all_educational_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userEducationalData: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor education by id
export const get_mentor_education_by_id_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userEducationByIdData: action.payload,
      };
    case mentorConstants.GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor profession
export const get_mentor_all_professional_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userProfessionalData: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor profession by id
export const get_mentor_profession_by_id_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userProfessionByIdData: action.payload,
      };
    case mentorConstants.GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor skills
export const get_mentor_all_skills_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_ALL_SKILLS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_SKILLS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userSkillsData: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_SKILLS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//create mentor skills
export const create_mentor_skills_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.CREATE_MENTOR_SKILLS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.CREATE_MENTOR_SKILLS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        newUserSkillData: action.payload,
      };
    case mentorConstants.CREATE_MENTOR_SKILLS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//Dashboard  mentor skills
export const get_mentor_dashboard_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        mentorDashboardData: action.payload,
      };
    case mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// Dashboard  mentor skills
export const get_mentor_kanbanboard_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_KANBANBOARD_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_KANBANBOARD_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        filteredList: action.payload,
        status: action.status,
      };
    case mentorConstants.GET_MENTOR_KANBANBOARD_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor profile
export const view_mentor_profile_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.VIEW_MENTOR_PROFILE_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.VIEW_MENTOR_PROFILE_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        viewMentorProfileInfo: action.payload,
      };
    case mentorConstants.VIEW_MENTOR_PROFILE_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor portfolio
export const get_mentor_all_portfolio_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userPortfolioData: action.payload,
      };
    case mentorConstants.GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_assigned_candidates_kanban_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_ASSIGNED_CANDIDATES_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_ASSIGNED_CANDIDATES_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assignedCandiatesList: action.payload,
      };
    case mentorConstants.GET_ASSIGNED_CANDIDATES_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


// get invited candidates reducer
export const get_invited_candidates_kanban_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorConstants.GET_INVITED_CANDIDATES_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorConstants.GET_INVITED_CANDIDATES_ACTION_SUCCESS:
      return {
        type: "alert-success",
        invitedCandiatesList: action.payload,
      };
    case mentorConstants.GET_INVITED_CANDIDATES_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


